module.exports = __webpack_public_path__ + "img/SES_205258053.115514fb.jpg";